import { useSearchParams } from "react-router"
import { getInsensitiveSearchParams } from "@/lib/get-insensitive-search-params"

export const useVideoCallAppointmentParam = () => {
  const [searchParams] = useSearchParams()

  return getInsensitiveSearchParams(searchParams, "appointmentId").value
}
